import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import MainPageSection from "./MainPageSection";
import AppHeader from "../../components/Header/AppHeader";
import LazyLoading from "../../components/LazyLoading/LazyLoading";
import { getCookiesSession } from "../../cookiesSession";
import { selectUserData } from "../../redux/selectors";

const MainPage = () => {
  const navigate = useNavigate();
  const currentUser = useSelector(selectUserData);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const session = getCookiesSession("trueCounselUserDataMaster");
    if (!session) {
      navigate("/login");
      return;
    }
    setIsReady(true);
  }, [navigate]);

  const firstName = useMemo(() => {
    const name = currentUser?.name?.trim();
    if (!name) return "";
    return name.split(" ")[0];
  }, [currentUser?.name]);

  if (!isReady) {
    return <LazyLoading message="Loading your workspace..." />;
  }

  return (
    <div className="flex h-screen flex-col bg-gradient-to-b from-slate-50 to-[#46BDE1]/10">
      <AppHeader />

      <main className="flex flex-col items-center justify-between w-full h-full py-10">
        <section className="flex flex-col items-center text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">
            {firstName ? `Welcome back, ${firstName}` : "Welcome back"}
          </h1>
          <p className="mt-2 max-w-xl text-sm text-slate-500 md:text-base">
            Choose a manager below to continue to your workspace.
          </p>
        </section>

        <MainPageSection />
      </main>
    </div>
  );
};

export default MainPage;
